import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import useAuth from "../Hooks/useAuth";
import axios from "../shared";
import Mandatory from "../Components/Mandatory";

const BookAppointment = () => {
  const { id } = useParams();
  const { auth } = useAuth();
  const [alert, setAlert] = useState(null);
  const [values, setValues] = useState();
  const [count, setCount] = useState(0);
  const [appointment, setAppointment] = useState({
    scheduled_by: auth?.user.id,
    doctor_id: id,
    patient_name: auth?.user.name,
  });

  const [selectedTime, setSelectedTime] = useState(null);
  const [interval, setInterval] = useState();
  const [availableDate, setAvailableDate] = useState();

  const [file, setFile] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [pidx, setpidx] = useState("");
  const [khaltiUrl, setKhaltiUrl] = useState("");

  const [onlinePayment, setOnlinePayment] = useState(false);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onChange = (e) => {
    if (e.target.name === "report_image") {
      setFile({ image: e.target.files });
    } else {
      setAppointment({ ...appointment, [e.target.name]: e.target.value });
    }

    //gets the time based on date chosen
    if (e.target.name === "appointment_date") {
      if (e.target.value === "Available Dates") {
        setInterval();
      } else {
        fetchTime(e.target.value);
      }
    }
  };

  const fetchTime = async (date) => {
    try {
      const response = await axiosPrivate(
        `user/doctor/${id}/time/?date=${date}`
      );
      setInterval(response?.data.available_times);
    } catch (err) {
      showAlert("Load Failed", "warning");
    }
  };

  const handleRadioChange = (time) => {
    setSelectedTime(time);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axiosPrivate.get(`user/doctor/${id}`);
        const count = await axiosPrivate.get(`appointment/count/${id}/`);
        const dates = await axiosPrivate.get(`user/doctor/${id}/dates/`);
        setCount(count.data);
        setValues(response.data);
        setAvailableDate(dates?.data.available_dates);
      } catch (err) {
        showAlert("Doctor not found. Reload", "warning");
      }
    }
    fetchData();
  }, []);

  const onBtnClick = async (e) => {
    // checks if all the required fields are filled or not
    if (Object.keys(appointment).length <= 5 || selectedTime === null) {
      showAlert("Fill Up all the fields.", "warning");
    } else if (appointment.appointment_date === "Available Dates") {
      showAlert("Choose a specific date for appointment.", "warning");
    } else if (appointment.reason === "Choose Your Reason") {
      showAlert("Choose a specific reason for visit.", "warning");
    } else {
      try {
        const data = {
          patient_name: auth?.user.name,
          patient_id: auth?.user.id,
          fees: values?.fees,
        };
        const payment = await axiosPrivate.post("payment/", data);
        setOnlinePayment(true);
        setKhaltiUrl(payment.data.payment_url);
        setpidx(payment?.data.pidx);
      } catch (error) {
        showAlert("Online Payment is down. You can pay manually.", "info");
      }
      document.getElementById("modal-open").click();
    }
  };

  const onCLick = async (option) => {
    const formData = new FormData();
    //file is appended after checking its existence
    if (file) {
      formData.append("report_image", file.image[0]);
    }

    //appending value of appointment in formData
    for (const key in appointment) {
      formData.append(key, appointment[key]);
    }

    //appending id of time in formData
    formData.append("appointment_time", selectedTime);

    try {
      if (option === "online") {
        //if online payment is active redirects to khalti
        formData.append("pidx", pidx);
        // loads page of khalti on successful save of data in dummy table
        const success = await axiosPrivate.post("payment/render/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (success.status === 201) {
          window.location.href = khaltiUrl;
        }
      } else {
        //saves appointment data as manual
        await axiosPrivate.post("appointment/?manual=True", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        document.getElementById("modal-close-btn").click();

        navigate("/list/appointment", {
          state: {
            message: "Appointment Booked.",
            type: "success",
          },
        });
      }
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert(
          err.response?.data["message"]
            ? err.response?.data["message"]
            : "Appointment is already scheduled at this time. Choose another time.",
          "warning"
        );
      } else if (err.response?.status === 404) {
        showAlert("You cannot book appointment.", "warning");
      } else {
        showAlert("Booking Failed", "warning");
      }
      document.getElementById("modal-close-btn").click();
    }
  };

  return (
    <div>
      <AlertField alert={alert} />

      <h2 className="text-center py-2">Book Appointment</h2>

      <div className="row row-cols-md-2 mx-3 px-2 mx-md-5 px-md-5 py-2 border bg-light">
        <div className="col px-md-5">
          <div className="row row-cols-md-2 flex-column flex-md-row align-items-center">
            <div className="d-flex justify-content-center">
              <img
                src={values?.user_detail.user_image}
                className="border border-5 border-dark rounded-circle"
                width={200}
                height={200}
                alt="doctor"
              />
            </div>
            <div className="text-center mt-2 mt-md-0 text-md-start">
              <h2>Dr. {values?.user_detail["name"].split(" ")[0] || ""}</h2>
              <h4>{values?.specialization}</h4>
              <h5>No. of Patients: {count}</h5>
            </div>
          </div>
          <div className="my-2 my-md-4">
            <h4 className="d-inline">Patient Name</h4>
            <input
              className="ms-2 ms-md-4 w-50"
              type="text"
              name="patient_name"
              id="patient_name"
              value={auth?.user.name}
              disabled
            />
            <h5 className="mt-2 mt-md-4">
              Reason for the visit:
              <Mandatory />
            </h5>
            <select
              id="inputState"
              className="form-select w-auto"
              name="reason"
              onClick={onChange}
            >
              <option defaultValue={"Choose Your Reason"}>
                Choose Your Reason
              </option>
              <option onClick={onChange}>General Check-Up</option>
              <option onClick={onChange}>Others</option>
            </select>
            <h5 className="mt-2 mt-md-4">
              Description:
              <Mandatory />
            </h5>
            <textarea
              name="description"
              id="description"
              className="p-2 w-100"
              rows="4"
              value={appointment?.description || ""}
              onChange={onChange}
            ></textarea>
          </div>
        </div>
        <div
          className={`col px-md-5 pb-5 pb-md-0 position-relative ${
            window.matchMedia("(min-width: 768px)").matches
              ? "border-5 border-white border-start"
              : "border-1"
          } `}
        >
          <div className="py-2 py-md-4">
            <h3>
              Schedule
              <Mandatory />
            </h3>
            <select
              id="inputState"
              className="form-select w-50"
              name="appointment_date"
              onClick={onChange}
            >
              <option defaultValue={"Choose Date"}>Available Dates</option>
              {availableDate?.map((day, i) => (
                <option onClick={onChange} key={i}>
                  {day}
                </option>
              ))}
            </select>
          </div>
          <div className="my-1">
            <h3>
              Available Time Slots
              <Mandatory />
            </h3>
            {interval ? (
              interval.length > 0 ? (
                <div
                  className="row row-cols-4 justify-content-space-between overflow-auto"
                  style={{ height: 7 + "rem" }}
                >
                  {interval?.map((schedule, i) => (
                    <div key={i}>
                      <input
                        type="radio"
                        className="btn-check"
                        name="time"
                        id={`time_${i}`}
                        autoComplete="off"
                        checked={schedule === selectedTime}
                        onChange={() => handleRadioChange(schedule)}
                      />
                      <label
                        className="btn btn-light border"
                        htmlFor={`time_${i}`}
                      >
                        {schedule}
                      </label>
                    </div>
                  ))}
                </div>
              ) : (
                <h6>No Time Slots Available</h6>
              )
            ) : (
              <h6 className="">Choose Appointment Date</h6>
            )}
          </div>
          <div className="py-2 py-md-4">
            <h5 className="d-inline">Upload</h5>
            <label className="ms-md-4 my-0">
              * You can upload old report to help you during consultation.
            </label>
            <input
              className="mt-2"
              type="file"
              name="report_image"
              id="report_image"
              accept="image/png, image/jpeg, application/pdf"
              onChange={onChange}
            />
          </div>
          <h5 className="d-inline mt-2">Charge</h5>
          <button className="mx-4 px-4 mb-5 mb-md-0">Rs. {values?.fees}</button>

          <div
            className="mt-4 w-100 text-center position-absolute"
            style={{ bottom: 1.5 + "rem" }}
          >
            <button className="btn btn-primary w-25" onClick={onBtnClick}>
              Pay
            </button>

            <button
              type="button"
              className="btn btn-primary w-100 d-none"
              id="modal-open"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            ></button>

            <div
              className="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                      Confirmation Payment
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <button
                      type="button"
                      className={`btn btn-primary mb-4 ${
                        !onlinePayment && "disabled"
                      }`}
                      onClick={() => onCLick("online")}
                    >
                      Pay with Khalti
                    </button>
                    <br />
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => onCLick("manual")}
                    >
                      Manual Payment
                    </button>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      id="modal-close-btn"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;
